"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_INFO_DIALOG_DRAWER_CLOSE_BUTTON = exports.PRODUCT_INFO_DIALOG_DRAWER = void 0;
const PRODUCT_INFO_DIALOG_DRAWER = exports.PRODUCT_INFO_DIALOG_DRAWER = 'product-info-dialog-drawer';
const PRODUCT_INFO_DIALOG_DRAWER_CLOSE_BUTTON = exports.PRODUCT_INFO_DIALOG_DRAWER_CLOSE_BUTTON = 'product-info-dialog-drawer-close-button';
